<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      filterAlpha: "",
      filteredValues: [],
      selectedValue: "",
      values: [],
      shortlist: [],
    };
  },

  props: ["url", "getUrl", "changeUrl", "initialShortlist"],

  mixins: [validateAndSubmit, validationClass],

  computed: {},

  created() {},

  mounted() {
    this.getData();
    this.shortlist = this.initialShortlist ? this.initialShortlist : [];
  },

  watch: {},

  methods: {
    getData() {
      axios
        .get(this.getUrl)
        .then((response) => {
          this.values = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    filterValues(letters) {
      var range = [];
      this.filterAlpha = letters;

      switch (letters) {
        case "AC":
          range = ["A", "B", "C"];
          break;
        case "DG":
          range = ["D", "E", "F", "G"];
          break;
        case "HN":
          range = ["H", "I", "J", "K", "L", "M", "N"];
          break;
        case "OR":
          range = ["O", "P", "Q", "R"];
          break;
        case "SZ":
          range = ["S", "T", "U", "V", "W", "X", "Y", "Z"];
          break;
      }

      this.filteredValues = this.values.filter(function (el) {
        return range.includes(el.value.substring(0, 1).toUpperCase());
      });
    },

    changeStatus(item) {
      this.selectedValue = item.key;
      var self = this;
      var newStatus = "missing";

      switch (item.status) {
        case "missing":
          newStatus = "interested";
          break;

        case "interested":
        case "former":
          newStatus = "shortlisted";
          break;

        case "shortlisted":
          newStatus = "top";
          break;
      }

      axios
        .post(this.changeUrl + "/" + this.selectedValue + "/" + newStatus)
        .then((response) => {
          if (response.data.success) {
            switch (newStatus) {
              case "missing":
                item.status = newStatus;
                break;

              case "interested":
                item.status = newStatus;
                break;

              case "shortlisted":
                this.shortlist.push(item);
                this.values.splice(
                  this.values.findIndex((e) => e.key === item.key),
                  1
                );
                this.filteredValues.splice(
                  this.filteredValues.findIndex((e) => e.key === item.key),
                  1
                );

                item.status = newStatus;
                break;

              case "top":
                this.$nextTick(() => {
                  self.validateAndSubmit("create-value-form");
                });
                break;
            }
          } else {
            switch (newStatus) {
              case "shortlisted":
                $("#shortListModal").modal("show");
                break;

              case "top":
                this.$root.$refs.toastr.e(response.data.message);
                break;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    resetItem() {
      var index = this.values.findIndex((e) => e.key === this.selectedValue);
      this.values[index].status = "missing";

      $("#shortListModal").modal("hide");
    },

    deleteFromShortlist(item) {
      this.shortlist.splice(
        this.shortlist.findIndex((e) => e.key === item.key),
        1
      );
      item.status = "interested";

      this.values.push(item);
      this.filterValues(this.filterAlpha);

      axios
        .post(this.changeUrl + "/" + item.key + "/interested")
        .then((response) => {
          //
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  components: {
    draggable,
  },
};
</script>
